<template>
  <div>
    <h1 class="title mqu-subtitle">Assumptions</h1>
    <h2 class="subtitle">Users may wish to view or change the calculator's default assumptions.</h2>
    <rv-has name="has-assumptions" label="Do you wish to view or change the default financial assumptions?" v-model="data.hasAssumptions" v-on:input="update"/>
    <transition name="fade" mode="out-in">
      <div v-if="data.hasAssumptions">
        <interest-rate v-model="data.interestRate" v-on:input="update"/>
        <inflation-rate v-model="data.inflationRate" v-on:input="update"/>
        <risk-free-interest-rate v-model="data.riskFreeInterestRate" v-on:input="update"/>
        <real-estate-volatility v-model="data.realEstateVolatility" v-on:input="update"/>
        <rental-yield v-model="data.rentalYield" v-on:input="update"/>
      </div>
    </transition>
  </div>
</template>

<script>
import InterestRate from '../inputs/assumptions/InterestRate'
import InflationRate from '../inputs/assumptions/InflationRate'
import RiskFreeInterestRate from '../inputs/assumptions/RiskFreeInterestRate'
import RealEstateVolatility from '../inputs/assumptions/RealEstateVolatility'
import RentalYield from '../inputs/assumptions/RentalYield'
import RealEstateInflationRate from '../inputs/assumptions/RealEstateInflationRate'
import Gap from '../inputs/assumptions/Gap'
import RvHas from '../inputs/RvHas'

export default {
  props: ['value'],
  inject: ['$validator'],
  components: {
    RvHas,
    Gap,
    RealEstateInflationRate,
    RentalYield,
    RealEstateVolatility,
    RiskFreeInterestRate,
    InflationRate,
    InterestRate
  },
  data() {
    return {
      data: {
        hasAssumptions: this.value.hasAssumptions,
        interestRate: this.value.interestRate,
        inflationRate: this.value.inflationRate,
        riskFreeInterestRate: this.value.riskFreeInterestRate,
        realEstateVolatility: this.value.realEstateVolatility,
        rentalYield: this.value.rentalYield
      },
      defaultData: {
        hasAssumptions: this.value.hasAssumptions,
        interestRate: this.value.interestRate,
        inflationRate: this.value.inflationRate,
        riskFreeInterestRate: this.value.riskFreeInterestRate,
        realEstateVolatility: this.value.realEstateVolatility,
        rentalYield: this.value.rentalYield
      }
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    }
  },
  watch: {
    'data.hasAssumptions': function(val) {
      if (val === false) {
        this.data = JSON.parse(JSON.stringify(this.defaultData))
        this.update()
      }
    }
  }
}
</script>

<style scoped>
.mqu-title {
  font-family: 'National-Extrabold';
}

.mqu-subtitle {
  font-family: 'National-Light';
}
</style>



// WEBPACK FOOTER //
// src/components/modules/stages/Assumptions.vue